<template>
    <div>
        <v-row>
            <transition name="scroll-x-reverse-transition">
                <v-col class="d-flex mt-5" cols="12">
                    <div class="flex-grow-1">
                        <v-radio-group v-model="selection">
                            <v-radio
                                value="email"
                                label="Email code Two-Factor Authentication (2FA) (Application Default)"
                            ></v-radio>
                        </v-radio-group>
                        <p :class="{ disabled: selection !== 'email' }" class="mt-5">
                            <span class="d-block font-weight-bold mb-2">This method is activated by default</span>
                            Email code Two-Factor Authentication (2FA) enhances account security with a two-step
                            verification process. After entering your credentials, a time-sensitive verification code is
                            sent via email. This code acts as a second layer of security, ensuring only authorized
                            access. Email code 2FA effectively guards against cyber threats.
                        </p>
                    </div>
                </v-col>
            </transition>
        </v-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selection: 'email',
        };
    },
};
</script>

<style scoped></style>
